<template>
    <div>
        <div class="top-room">
            <PublicForm class="double-form" :width="'100px'" :formData="formData" :formList="cols" />
        </div>
        <div class="listTable">
            <div class="margins">
                <span>
                    <el-button class="base-button" size="mini" type="primary" @click="machineSelf">本机自发自收测试</el-button>
                </span>
                <span>
                </span>
            </div>
            <YzTable :hasPage="false" :afterRequest="afterRequest" max-height="310px" :columnApi="columns" :listApi="listArray" :searchForm="searchForm" :autoLoad="true"
                ref="YzTable" />
        </div>
    </div>
</template>

<script>
import { getSerialPort } from "@/api/device/index.js";
import sendMSG from "./sendMSG.vue"
export default {
    data() {
        return {
            columns: "json/cardList.json",
            listArray: "/system/zhj/getZhjBdCardList",
            searchForm: {
            },
            formData: {},
            cols: [
                // {
                //     "label": "卡位",
                //     "cusprop": "index",
                //     "component": "popContent"
                // },
                // {
                //     "label": "卡号",
                //     "cusprop": "cardID",
                //     "component": "popContent"
                // },
                // {
                //     "label": "通播号",
                //     "cusprop": "broadcastID",
                //     "component": "popContent"
                // },
                // {
                //     "label": "频度",
                //     "cusprop": "frequency",
                //     "component": "popContent"
                // },
                {
                    "label": "串口号",
                    "cusprop": "serialPortName",
                    "component": "popContent"
                },
                {
                    "label": "波特率",
                    "cusprop": "serialPortBaudrate",
                    "component": "popContent"
                },
                {
                    "label": "串口连接状态",
                    "component": "commonSwitch",
                    "cusprop": {
                        "prop": "connectionStatus",
                        "mapping": {
                            "connectSuccess": "连接成功",
                            "connectFail": "连接失败",
                            "connectCut": "正在连接"
                        }
                    }
                },
            ]
        };
    },

    created() {
        this.getSerialPort();
    },
    mounted() {

    },

    methods: {
        machineSelf() {
            this.$dialog.open({
                title: "自发自收测试",
                theme: "feature-dialog",
                shade:true,
                area: {
                    height: "240px",
                    width: "680px",
                },
                content: {
                    type: "vue",
                    subCom: sendMSG,
                },
            });
        },
        afterRequest(res) {
            return {
                result: {
                    items: res.result,
                    total: 0
                }
            }
        },
        getSerialPort() {
            getSerialPort().then(res => {
                this.formData = res.result || {};
            }).catch(e => {
                console.error(e);
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.top-room{
    border:solid 1px #3AB0E3;
    margin:20px;
}
</style>